import { useState, useEffect } from 'react';

const MOBILE_QUERY = '(max-width: 767px)';

/**
 * Returns true when the viewport is mobile-width (< 768px).
 *
 * Uses window.matchMedia with a change listener so it reacts to resize.
 * Defaults to false (desktop) when matchMedia is unavailable (jsdom / SSR),
 * which keeps existing desktop tests unaffected.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(MOBILE_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    const mql = window.matchMedia(MOBILE_QUERY);
    const handler = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
    };

    mql.addEventListener('change', handler);
    // Sync once on mount in case state drifted between init and effect
    setIsMobile(mql.matches);

    return () => {
      mql.removeEventListener('change', handler);
    };
  }, []);

  return isMobile;
}
